import Vue from "vue";
import axios from "axios";
import qs from "qs";
// import layerActual from 'vue-layer'
import store from "../store";
// import 'vue-layer/lib/vue-layer.css'
import { getOpenid } from "@/utils/auth";
import { Toast } from "vant";
import cookie from "js-cookie";
// import { encryptToken } from '@/utils/encrypt'
// const layer = layerActual(Vue)

// 创建axios实例
var protocolStr = "https:"; // 判断是http还是https
if (protocolStr == "http:") {
  store.commit("GET_InterfacePath", protocolStr + "//school.striveing.com/"); // 医药云课堂正式服
  // store.commit("GET_InterfacePath", protocolStr + "//www.1010study.com/"); // 新陆职业正式服
  // store.commit("GET_InterfacePath", protocolStr + "//www.jiyou-tech.com:8980/"); // 医药云课堂测试服
  // store.commit("GET_InterfacePath", protocolStr + "//192.168.1.6:898/"); // 医药云课堂测试服
  // store.commit("GET_InterfacePath", protocolStr + "//main.jiyou-tech.com:898/"); // 云课堂
} else if (protocolStr == "https:") {
  store.commit("GET_InterfacePath", protocolStr + "//school.striveing.com/"); // 医药云课堂正式服
  // store.commit("GET_InterfacePath", protocolStr + "//www.1010study.com/"); // 新陆职业正式服
  // store.commit("GET_InterfacePath", protocolStr + "//www.jiyou-tech.com:8980/"); // 医药云课堂测试服
  // store.commit("GET_InterfacePath", protocolStr + "//192.168.1.6:898/"); // 医药云课堂测试服
  // store.commit("GET_InterfacePath", protocolStr + "//main.jiyou-tech.com:8980/"); // 云课堂
}
const request = axios.create({
  // baseURL: "//192.168.1.6:898/" + "api/",
  baseURL: store.state.interfacePath + "api/",
  timeout: 600000, // 请求超时时间
  transformRequest: (data) => {
    return qs.stringify(data);
  },
  paramsSerializer: {
    serialize: (params) => qs.stringify(params),
  },
});
const loadingWhite = []; // 禁止loading名单
let loading = 0;
let layerLoad = null; // loading实例
// request拦截器
request.interceptors.request.use(
  (config) => {
    if (loadingWhite.indexOf(config.url) === -1) {
      loading++;
    }
    if (!layerLoad && loading) {
      // layerLoad = layer.loading({ content: '请求中', shade: true, shadeClose: false })
    }
    let TOKEN = "";
    if (cookie.get("Token")) {
      TOKEN = cookie.get("Token");
    } else {
      TOKEN = store.state.tokenCode;
    }
    // console.log(TOKEN);
    if (TOKEN) {
      config.headers["user-token"] = TOKEN;
    }
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// response 拦截器
request.interceptors.response.use(
  (response) => {
    // console.log(response);
    return response;
    // const res = response.data;
    // if (loading) {
    //   loading--;
    //   if (loading === 0) {
    //     // layer.close(layerLoad)
    //     // Toast.close(layerLoad)
    //     layerLoad = null;
    //   }
    // }
    // if (res.code !== 0) {
    //   // layer.msg(res.msg)
    //   Toast(res.msg);
    //   if (res.code === -102) {
    //     location.reload();
    //   }
    //   return Promise.reject(res.msg);
    // } else {
    //   return res;
    // }
  },
  (error) => {
    console.log(error);
    if (loading) {
      // layer.close(layerLoad)
      layerLoad = null;
    }
    if (error.toString().indexOf("Error: timeout") !== -1) {
      // layer.msg('网络请求超时')
      Toast("网络请求超时");
      return Promise.reject(error);
    }
    return Promise.reject("网络请求超时");
  }
);
export default request;
